module.exports = __webpack_public_path__ + "static/media/matheus_lima.2e04867f.jpg";